import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { getLast24MonthsDates } from "../../utils/getLast24Months";
import { ApiHook } from "../../hooks/apiHook";

const CcSummary = ({ kcSummaryData }) => {
  const { t } = useTranslation();
  const filterData = getLast24MonthsDates();

  const [value, setValue] = useState(0);
  const [filterValue, setFilter] = useState(true);
  const [date, setDate] = useState(filterData[0]);

  const summary = ApiHook.CallCCSummmary(filterValue, setFilter, date);

  const handleChange = (event, newValue) => {
    setDate(filterData[newValue]);
    setFilter(true);
    setValue(newValue);
  };

  return (
    <div className="cc_overview_sec">
      <h6 style={{ padding: "10px" }}>KC points summary</h6>

      <div className="cc_table_conetnt">
        <div className="block">
          <span className="key">{t("4kcActive")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.activeStatus ? "YES" : "NO"}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("LbQualified")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.leadershipStatus ? "YES" : "NO"}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("ativeManagers")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.downlineLeaderCount ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("personalPV")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.personalPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("guestPv")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.guestPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("leaderPv")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.leaderPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("nonManagerPv")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.nonManagerPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("totalPv")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.totalPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("passPv")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.passPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("newPv")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.newPv ?? 0}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("activityWaiver")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.activityWaiver ? "YES" : "NO"}
          </span>
        </div>
        <div className="block">
          <span className="key">{t("leadershipWaiver")}</span>
          <span className="value">
            {summary?.data?.pointsSummary?.leadershipWaiver ? "YES" : "NO"}
          </span>
        </div>
      </div>
      <div className="cc_filter_tab">
        <Box
          sx={{ maxWidth: { xs: 150, sm: 350 }, bgcolor: "background.paper" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            {filterData.map((monthObj) => (
              <Tab label={monthObj} />
            ))}
          </Tabs>
        </Box>
      </div>
    </div>
  );
};

export default CcSummary;
